export default "__VITE_ASSET__DnKFizYa__"